import {
  type RejectEntitySuggestionRequest,
  type RejectEntitySuggestionResponse
} from '@bliks-io/contracts';
import {
  invalidateSuggestionResolutionSurfaces,
  useEntitySuggestionAction
} from './useEntitySuggestionAction';

export function useRejectEntitySuggestion(suggestionId: string) {
  return useEntitySuggestionAction<RejectEntitySuggestionRequest, RejectEntitySuggestionResponse>({
    suggestionId,
    verb: 'reject',
    // Rejection re-renders the suggestion's refs as declined but creates no
    // entity, so the systems/teams lists stay untouched.
    extraInvalidations: (qc) => invalidateSuggestionResolutionSurfaces(qc, { entityLists: false })
  });
}
